import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminDrawPage from './pages/AdminDrawPage';
import DrawResultPage from './pages/DrawResultPage';
import MyLetterPage from './pages/MyLetterPage';
import FamilyLettersPage from './pages/FamilyLettersPage';
import InspirationsPage from './pages/InspirationsPage';
import MessagesPage from './pages/MessagesPage';
import ConversationPage from './pages/ConversationPage';
import './index.css';

function AdminPlaceholder({ label }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚧</div>
      <h3 style={{ color: 'var(--gold)', fontFamily: 'var(--font-display)' }}>{label}</h3>
      <p>Se añadirá en la siguiente fase</p>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route path="/home" element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } />

          <Route path="/amigo-invisible" element={
            <ProtectedRoute>
              <DrawResultPage />
            </ProtectedRoute>
          } />

          <Route path="/mi-carta" element={
            <ProtectedRoute>
              <MyLetterPage />
            </ProtectedRoute>
          } />

          <Route path="/cartas-familia" element={
            <ProtectedRoute>
              <FamilyLettersPage />
            </ProtectedRoute>
          } />

          <Route path="/inspiraciones" element={
            <ProtectedRoute>
              <InspirationsPage />
            </ProtectedRoute>
          } />

          <Route path="/mensajes" element={
            <ProtectedRoute>
              <MessagesPage />
            </ProtectedRoute>
          } />

          <Route path="/mensajes/con/:userId" element={
            <ProtectedRoute>
              <ConversationPage mode="normal" />
            </ProtectedRoute>
          } />

          <Route path="/mensajes/amigo-invisible/:relatedUserId" element={
            <ProtectedRoute>
              <ConversationPage mode="anon-sender" />
            </ProtectedRoute>
          } />

          <Route path="/mensajes/respondiendo/:relatedUserId" element={
            <ProtectedRoute>
              <ConversationPage mode="anon-receiver" />
            </ProtectedRoute>
          } />

          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="usuarios" replace />} />
            <Route path="usuarios" element={<AdminUsersPage />} />
            <Route path="sorteo" element={<AdminDrawPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
